import { type Profile } from "../../profile/profile.models"
import { wizedService } from "./wized.service";

class WebFlowService {
  onLogout() {
    // console.log("Webflow::Logout")
    window.location.reload()
  }

  async onLogin(infos: Profile) {
    if (!infos.id || !infos.userEmail) { console.warn("missing infos in ", infos); return }

    await wizedService.onLogin(infos)
  }
}

export const webFlowService = new WebFlowService()
